import { Box, styled } from '@mui/material';

export const StyledDisplayDataBox = styled(Box)`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: white;
`;
